import { IItemOption } from '@rbi-ctg/menu';
import { IPricingAndAvailabilityFragment } from 'generated/graphql-gateway';
import { isMobile } from 'utils/environment';

const DEFAULT_OFFSET = 100;
const MAIN_LAYOUT_SELECTOR = '[data-testid="main-layout"]';

export const MOBILE_TABBED_HEADER_TEST_ID = 'tabbed-menu-header';
export const DESKTOP_TABBED_HEADER_TEST_ID = 'desktop-menu-tabbed-header';
export const APP_HEADER_TEST_ID = 'app-header';

export const MAIN_CONTENT_SELECTOR = '#main';
export const APP_HEADER_ELEMENT_SELECTOR = `[data-testid=${APP_HEADER_TEST_ID}]`;
export const DESKTOP_TABBED_HEADER_SELECTOR = `[data-testid="${DESKTOP_TABBED_HEADER_TEST_ID}"]`;
export const MOBILE_TABBED_HEADER_SELECTOR = `[data-testid="${MOBILE_TABBED_HEADER_TEST_ID}"]`;

export const getMenuSectionId = (id: string) => `section-${id}`;
export const getSectionIdFromHash = (hash: string) => hash.replace('#section-', '');

export type IItemOptionWithId = IItemOption & { _id: string };

type ScrollIntoViewOptions = ScrollToOptions & {
  offset?: number;
};

type AvailabilityFilterFn<T> = (
  predicateFn: (itemId: string) => IPricingAndAvailabilityFragment | null
) => (item: T) => boolean;

// #region Helpers
const getTabbedHeaderElementHeight = (onMobile: boolean = isMobile()): number => {
  let tabbedHeaderElement: HTMLElement | null = null;

  if (onMobile) {
    tabbedHeaderElement = document.querySelector(MOBILE_TABBED_HEADER_SELECTOR);
  } else {
    tabbedHeaderElement = document.querySelector(DESKTOP_TABBED_HEADER_SELECTOR);
  }

  return tabbedHeaderElement?.clientHeight ?? DEFAULT_OFFSET;
};

const getAppHeaderElementHeight = (): number => {
  const appHeaderElement = document.querySelector(APP_HEADER_ELEMENT_SELECTOR);

  return appHeaderElement?.clientHeight ?? 0;
};

export const getTotalHeaderHeight = (onMobile?: boolean): number => {
  return getAppHeaderElementHeight() + getTabbedHeaderElementHeight(onMobile);
};

export const isItemAvailable: AvailabilityFilterFn<IItemOptionWithId> = predicateFn => item => {
  return predicateFn(item._id)?.isAvailable ?? false;
};
// #endregion

export const scrollSectionIntoView = (id: string, options: ScrollIntoViewOptions = {}) => {
  const element = document.querySelector(`#${getMenuSectionId(id)}`);
  const mainLayout = document.querySelector(MAIN_LAYOUT_SELECTOR);

  const tabbedHeaderHeight = getTabbedHeaderElementHeight();

  const { offset, ...rest } = options;

  if (element instanceof HTMLElement && mainLayout instanceof HTMLElement) {
    mainLayout.scrollTo({
      top: element.offsetTop - (offset ?? tabbedHeaderHeight) + 12,
      behavior: 'smooth',
      ...rest,
    });
  }
};
